import React from 'react';
import styled from 'styled-components';
import { Button, Copy, Heading } from 'components/components/atoms';
import breakpoints from 'utils/breakpoints';
import trackAnalyticsEvent from 'utils/trackAnalyticsEvent';

const Card = styled.div`
  min-height: 15rem;

  @media ${breakpoints.md} {
    min-height: 15rem;
  }
`;

const PromotionContent = styled.div`
  @media ${breakpoints.lg} {
    min-height: 15rem;
  }
`;

const CopyContainer = styled.div`
  min-height: 3.75rem;
`;

const Logo = styled.img`
  height: 2.5rem;

  @media ${breakpoints.md} {
    height: 3.5rem;
  }
`;

const StyledButton = styled(Button)`
  width: auto;
  height: 3.125rem;
  padding: 0 1.5rem;

  & > div {
    min-width: 5.75rem;
  }
`;

const PromotionSearchCard = ({ promotion }) => {
  const handlePromotionClick = () => {
    trackAnalyticsEvent({
      gtagEvent: 'SearchFeaturedPromoClick',
      mouseflowTag: 'SearchFeaturedPromoClick',
    });
  };

  return (
    <div className='flex h-full w-full self-stretch'>
      <Card className='mt-4 mb-6 flex flex-1 rounded-lg bg-mattamy-blue text-white md:mb-4 md:mt-4'>
        <div className='h-full flex w-full flex-col items-start justify-center px-6 py-6 md:px-8 lg:px-10'>
          <Logo src={promotion.logo} alt={promotion.logoAlt} className='mb-2' />

          <Heading noMargin color='white'>
            {promotion.title}
          </Heading>

          <span className='mb-2 block font-trade-gothic-20 text-sm uppercase text-aqua'>
            {promotion.rateLabel}
          </span>
          <CopyContainer>
            <Copy className='mb-5 max-w-3xl text-sm' color='white'>
              {promotion.description}
            </Copy>
          </CopyContainer>

          {promotion.cta.text && promotion.cta.href && (
            <StyledButton
              href={promotion.cta.href}
              target={promotion.cta.target}
              color='white'
              textColor='mattamy-blue'
              variant='outlined'
              buttonDescription={promotion.cta.text}
              linkWrapperDescription={promotion.cta.text}
              onClick={handlePromotionClick}
            >
              {promotion.cta.text}
            </StyledButton>
          )}
        </div>
      </Card>
    </div>
  );
};

export default PromotionSearchCard;
